module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    on: {
      "mouseenter": _vm.mouseenter,
      "mouseleave": _vm.mouseleave,
      "click": _vm.show
    }
  }, [(_vm.multiple) ? _c('div', {
    staticClass: "multiple-lookup-wrap"
  }, [(_vm.list && _vm.list.length > 0) ? _c('div', {
    staticClass: "lookup-main"
  }, [(_vm.max) ? [_vm._l((_vm.list.slice(0, 2)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tag"
    }, [_c('span', {
      staticClass: "tag-text"
    }, [_vm._v(_vm._s(item[_vm.alias.name]))]), _vm._v(" "), _c('rt-icon', {
      staticClass: "tag-close",
      attrs: {
        "name": "rt-base-close_fill"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.del(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('el-popover', {
    ref: "popover",
    attrs: {
      "content": _vm.contentPopover,
      "trigger": "hover"
    },
    on: {
      "show": _vm.showPopover
    }
  }, [_c('div', {
    staticClass: "tag",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "tag-text tag-num"
  }, [_vm._v("+ " + _vm._s(_vm.list.length - 2))])])])] : _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tag"
    }, [_c('span', {
      staticClass: "tag-text"
    }, [_vm._v(_vm._s(item[_vm.alias.name]))]), _vm._v(" "), _c('rt-icon', {
      staticClass: "tag-close",
      attrs: {
        "name": "rt-base-close_fill"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.del(index)
        }
      }
    })], 1)
  })], 2) : _c('div', {
    staticClass: "select-placeholder"
  }, [_c('span', [_vm._v("请选择")])])]) : _vm._e(), _vm._v(" "), (!_vm.multiple) ? _c('div', {
    staticClass: "single-lookup-wrap"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "value": _vm.inputText,
      "placeholder": _vm.placeholder,
      "readonly": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('rt-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showClose && !_vm.disabled),
      expression: "!showClose && !disabled"
    }],
    attrs: {
      "name": "rt-base-lookup"
    }
  }), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clear($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('rt-dialog', {
    staticClass: "lookup-dialog",
    attrs: {
      "append-to-body": true,
      "title": _vm.title,
      "size": "large"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('rt-lookup-view', {
    ref: "lookupView",
    attrs: {
      "fetch": _vm.fetchRecord,
      "display-fields": _vm.displayFields,
      "multiple": _vm.multiple,
      "title": _vm.title,
      "total": _vm.total
    },
    on: {
      "change": _vm.change
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9069c1d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtLookup.vue
// module id = 1536
// module chunks = 72